import React from 'react';
import { TaskStatus } from '../../../../../../../ReactSharedScripts/modules/activity/activityTaskList/const';
import { MovingGradient } from '../../../../../../../ReactSharedScripts/components/MovingGradient';
import { TaskListBoardColumn } from './TaskListBoardColumn';
import { TaskListBoardColumnHeader } from './TaskListBoardColumnHeader';
import classes from './styles/index.module.scss';
import { ListHorizontalScroll } from '../../../../list/components/ListHorizontalScroll';

const cards = Array.from(Array(5).keys());

export const TaskListBoardPlaceholder: React.FC = () => {
	const entityStateIdsList = [TaskStatus.ToDo, TaskStatus.InProgress, TaskStatus.Done];

	return (
		<ListHorizontalScroll
			className={`${classes.taskBoard_flexHeight} taskBoard_flexHeight`}
			classNameContent={classes.taskBoard_flexHeight}
		>
			<div className={classes.taskBoard}>
				{entityStateIdsList.map((stateId) => (
					<TaskListBoardColumn key={stateId}>
						<TaskListBoardColumnHeader
							entityStateId={stateId}
							length={0}
						/>
						{cards.map((id) => (
							<MovingGradient
								height={'100px'}
								borderRadius={'4px'}
								key={id}
							/>
						))}
					</TaskListBoardColumn>
				))}
			</div>
		</ListHorizontalScroll>
	);
};
